import React, { useState } from 'react';
import HeaderBanner from '../HeaderBanner';
import API_ENDPOINTS from '../../Config/api';
import useGet from '../../Hooks/useGet';
import usePatch from '../../Hooks/usePatch';
import { useNavigate, useParams } from 'react-router-dom';
import { Icon } from '../UI/Icon';
import ClipLoader from 'react-spinners/ClipLoader';
import Selector from './../UI/Selector';

export default function CompanyForm() {
  const { id } = useParams();
  const [dipendenti, setDipendenti] = useState('');
  const [fatturato, setFatturato] = useState('');
  const [idSettore, setIdSettore] = useState('');

  const { fetchedData: settori, loading } = useGet(API_ENDPOINTS.getSettori);
  const { patchData } = usePatch();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await patchData(API_ENDPOINTS.setTipoAzienda, {
        numero_dipendenti: dipendenti,
        fatturato_annuo: fatturato,
        id_settore: Number(idSettore), // converte la stringa in numero
      });

      // Passa alla pagina successiva solo dopo il salvataggio
      navigate(`/questionario/${id}`, { replace: true });
    } catch (err) {
      console.error('Errore nel salvataggio dati azienda:', err);
    }
  };

  // Ordina l’array dei settori in ordine alfabetico
  // Null-safe alphabetical sort for 'settore'
  const sortedSectors = settori
    ? [...settori].sort((a, b) => String(a.settore || '').localeCompare(String(b.settore || '')))
    : [];

  // Troviamo l'oggetto del settore selezionato (se c'è)
  const selectedSettore = sortedSectors.find(
    (item) => String(item.id_settore) === String(idSettore)
  );

  const selectorOptions = sortedSectors.map((item) => ({
    label: item.settore || '',
    value: item.id_settore
  }));





  return (
    <div>
      <HeaderBanner
        title="Informazioni Azienda"
        description="Check your compliance status with specific laws starting from the proposed questionnaire. Not only will you be able to quickly evaluate your current profile, but you will also be able to see which services you can purchase, estimate the costs and timescales and comply with the legal deadlines."
        linkTo="/compliance"
      />

      <div className="mx-auto max-w-5xl mt-5">
        <form onSubmit={handleSubmit} className="space-y-10">
          {/* Settore */}
          <div>
            <label
              htmlFor="settore"
              className="block mb-1 font-semibold text-gray-700"
            >
              Settore
            </label>
            <select
              id="settore"
              value={idSettore}
              onChange={(e) => setIdSettore(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-md 
                         focus:outline-none focus:ring-2 focus:ring-yellow-400 
                         focus:border-transparent transition-colors cursor-pointer"
              required
            >
              <option value="">Seleziona un settore</option>
              {sortedSectors.map((item) => (
                <option key={item.id_settore} value={item.id_settore}>
                  {item.settore}
                </option>
              ))}
            </select>
            {/* <Selector
              label={'Settore'}
              options={selectorOptions}
              width='w-full'
              onChange={setIdSettore}

            /> */}


            {/* Descrizione del settore selezionato */}
            {idSettore && selectedSettore && (
              <p className="mt-2 text-gray-600">{selectedSettore.descrizione}</p>
            )}
          </div>

          {/* Numero dipendenti */}
          <div>
            <label
              htmlFor="dipendenti"
              className="block mb-1 font-semibold text-gray-700"
            >
              Numero dipendenti
            </label>
            <input
              id="dipendenti"
              type="number"
              value={dipendenti}
              onChange={(e) => setDipendenti(e.target.value)}
              placeholder="Es. 50"
              className="w-full p-3 border border-gray-300 rounded-md 
                         focus:outline-none focus:ring-2 focus:ring-yellow-400 
                         focus:border-transparent transition-colors"
              required
            />
          </div>

          {/* Fatturato annuo */}
          <div>
            <label
              htmlFor="fatturato"
              className="block mb-1 font-semibold text-gray-700"
            >
              Fatturato annuo [€]
            </label>
            <input
              id="fatturato"
              type="number"
              step="0.01"
              value={fatturato}
              onChange={(e) => setFatturato(e.target.value)}
              placeholder="Es. 250000"
              className="w-full p-3 border border-gray-300 rounded-md 
                         focus:outline-none focus:ring-2 focus:ring-yellow-400 
                         focus:border-transparent transition-colors"
              required
            />
          </div>

          {/* Bottone di invio */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="flex gap-2 items-center bg-yellow-400 px-5 
                         py-2 text-black font-semibold rounded hover:bg-yellow-500 
                         transition-colors w-52"
            >
              {loading ? (
                <div className="flex w-full items-center justify-center">
                  <ClipLoader size={20} color="#ffffff" />
                </div>
              ) : (
                <div className="flex gap-2 items-center">
                  Vai al questionario <Icon name="leftLongArrow" />
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
